import { SharedModule } from './../shared/shared.module';
import { NgModule } from '@angular/core';

import { RegionRoutingModule } from './region-routing.module';
import { RegionComponent } from './region.component';
import { HeaderComponent } from './components/header/header.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { HomeComponent } from './components/home/home.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { SanctionedPostListComponent } from './components/sanctioned-post/sanctioned-post-list/sanctioned-post-list.component';
import { SanctionedPostFormComponent } from './components/sanctioned-post/sanctioned-post-form/sanctioned-post-form.component';
import { VacantPostListComponent } from './components/vacant-post/vacant-post-list/vacant-post-list.component';
import { VacantPostFormComponent } from './components/vacant-post/vacant-post-form/vacant-post-form.component';
import { EmployeeListComponent } from './components/employee/employee-list/employee-list.component';
import { EmployeeFormComponent } from './components/employee/employee-form/employee-form.component';
import { TransferRequestListComponent } from './components/transfer-request/transfer-request-list/transfer-request-list.component';
import { TransferRequestFormComponent } from './components/transfer-request/transfer-request-form/transfer-request-form.component';
import { RegionProfileService } from './region-profile.service';
import { TransferRequestViewComponent } from './components/transfer-request-view/transfer-request-view.component';
import { StatisticComponent } from './components/statistic/statistic.component';

import { ProfileContactFormComponent } from './components/employee/profile-contact-form/profile-contact-form.component';
import { ProfileFormComponent } from './components/employee/profile-form/profile-form.component';
import { ServiceBookListComponent } from './components/employee/service-book/service-book-list/service-book-list.component';
import { ServiceBookFormComponent } from './components/employee/service-book/service-book-form/service-book-form.component';
import { PresentPlaceFormComponent } from './components/employee/service-book/present-place-form/present-place-form.component';
import { EmployeeProfileListComponent } from './components/employee-profile/employee-profile-list/employee-profile-list.component';
import { EmployeeProfileViewComponent } from './components/employee-profile/employee-profile-view/employee-profile-view.component';
import { ViewEmployeeProfileComponent } from './components/employee/view-employee-profile/view-employee-profile.component';

@NgModule({
  declarations: [
    RegionComponent,
    HeaderComponent,
    SidebarComponent,
    HomeComponent,
    BreadcrumbComponent,
    SanctionedPostListComponent,
    SanctionedPostFormComponent,
    VacantPostListComponent,
    VacantPostFormComponent,
    EmployeeListComponent,
    EmployeeFormComponent,
    TransferRequestListComponent,
    TransferRequestFormComponent,
    TransferRequestViewComponent,
    StatisticComponent,
    ProfileContactFormComponent,
    ProfileFormComponent,
    ServiceBookFormComponent,
    ServiceBookListComponent,
    PresentPlaceFormComponent,
    EmployeeProfileListComponent,
    EmployeeProfileViewComponent,
    ViewEmployeeProfileComponent
  ],
  imports: [
    SharedModule,
    RegionRoutingModule
  ],
  providers: [
    RegionProfileService
  ]
})
export class RegionModule { }
